// One type per category: all stove pipes alike, all Class A chimneys alike, all liners
// alike. Mixing across categories is normal — stove pipe into Class A is an ordinary
// installation. Elbows, tees and caps carry no type and are ignored.
import { findVentOption } from './data';
import { categoryTypeLabel, categoryNoun } from './ventTypeLabels';

export function mixedTypeErrors(items) {
  const byCategory = new Map();

  for (const item of items || []) {
    const option = item && item.ventOptionId ? findVentOption(item.ventOptionId) : null;
    if (!option) continue; // no type set, or an id the catalog doesn't know

    const seen = byCategory.get(option.category) || [];
    if (!seen.includes(option.name)) seen.push(option.name);
    byCategory.set(option.category, seen);
  }

  const errors = [];
  for (const [category, names] of byCategory) {
    if (names.length < 2) continue;
    errors.push(
      `All ${categoryNoun(category)} parts must use the same `
      + `${categoryTypeLabel(category)}. Found ${formatList(names)}.`,
    );
  }
  return errors;
}

// "A and B" / "A, B and C"
function formatList(names) {
  if (names.length <= 1) return names.join('');
  return `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`;
}
